/**
 * Monthly free premium games — update each month (keep in sync with be/src/config/monthlyFreeGames.ts).
 *
 * First 2 games in each pack are always free. These are the next 2 (positions 3–4).
 * To shuffle next month, replace the IDs below with two different premium game IDs from the pack.
 */
import { BLITZ_GAMES, PARTY_GAMES, TEAM_GAMES, FAMILY_GAMES } from './games';
import type { GameConfig } from './types';
import { config } from './index';

export type GamePack = 'blitz' | 'team' | 'family' | 'party';

/** Shown in the lobby banner, e.g. "July 2026". */
export const MONTHLY_FREE_PERIOD_LABEL = 'July 2026';

export const MONTHLY_FREE_GAME_IDS: Record<GamePack, readonly string[]> = {
  blitz: ['speed-challenge', 'picture-perfect'],
  team: ['business-brain-teasers', 'its-funny'],
  family: ['wonder-world', 'what-am-i'],
  party: ['are-you-drunk', 'rapid-fire'],
};

const PACK_GAMES: Record<GamePack, GameConfig[]> = {
  blitz: BLITZ_GAMES,
  team: TEAM_GAMES,
  family: FAMILY_GAMES,
  party: PARTY_GAMES,
};

export function isMonthlyFreeGame(gameId: string, pack?: GamePack): boolean {
  const packKey = pack ?? (config.appId as GamePack);
  const ids = MONTHLY_FREE_GAME_IDS[packKey];
  return ids?.includes(gameId) ?? false;
}

export function getMonthlyFreeGames(pack?: GamePack): GameConfig[] {
  const packKey = pack ?? (config.appId as GamePack);
  const ids = MONTHLY_FREE_GAME_IDS[packKey] ?? [];
  const games = PACK_GAMES[packKey] ?? [];
  return ids
    .map((id) => games.find((g) => g.id === id))
    .filter((g): g is GameConfig => g != null);
}
